<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-05-19 22:08:33
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div :class="['mymodal', `modal-${$setting.name}`, { animate: value && message.animate }]" :style="{ backgroundColor: message.bgColor }" v-show="value">
    <div class="info" :style="{ transform: this.message.animate ? 'scale(0)' : 'none' }">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <template v-if="message.nextInfo">
        <div class="msg-info">
          <div class="msgTitle" v-if="!(message.currentInfo.lotteryTimesInit - message.currentInfo.userLotteryCount == 0 && message.assistanceNumber == message.currentInfo.requireLevel)">{{ message.currentInfo.lotteryTimesInit - message.currentInfo.userLotteryCount == 0 && message.assistanceNumber == message.currentInfo.requireLevel ? "很遗憾！" : "恭喜您！" }}</div>
          <div class="msg1">
            <div class="tip1" v-html="text"></div>
          </div>
          <div
            v-if="message.assistanceNumber == message.currentInfo.requireLevel && message.currentInfo.lotteryTimesInit - message.currentInfo.userLotteryCount > 0 && message.currentInfo.prizeCount != 0"
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickLuck"
          >
            去抽奖
          </div>
          <div
            v-else
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtnConfirm"
          >
            呼朋唤友
          </div>
        </div>
      </template>

      <template v-else>
        <div class="msg-info">
          <div class="msgTitle">恭喜您！</div>
          <!-- <div class="msgTitle">{{ message.currentInfo.lotteryTimesInit - message.currentInfo.userLotteryCount == 0 ? "很遗憾！" : "恭喜你！" }}</div> -->
          <div class="msg1">
            <div class="tip1" v-html="text"></div>
          </div>

          <div
            v-if="message.currentInfo.lotteryTimesInit - message.currentInfo.userLotteryCount > 0 && message.currentInfo.prizeCount != 0"
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickLuck"
          >
            抽奖
          </div>
          <div
            v-else
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtnConfirm"
          >
            确定
          </div>
        </div>
      </template>

      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: {
        currentInfo: {},
      },
      configInfo: {},
      requireLevel: true,
      text: "",
    };
  },
  watch: {
    value: function (newVal) {
      if (newVal) {
        const { assistanceNumber, currentInfo, nextInfo, helpText } = this.message;
        console.log(this.message);
        if (nextInfo) {
          // 有下一站
          if (assistanceNumber == currentInfo.requireLevel) {
            this.text = `您成功点亮${currentInfo.name}，获得抽奖机会，超多精彩好礼等您来抽！`;
          }

          if (currentInfo.prizeCount == 0) {
            this.text = `您成功点亮${currentInfo.name}站，呼朋唤友点亮下一站,超多精彩好礼等您来拿！`;
          } else if (currentInfo.lotteryTimesInit - currentInfo.userLotteryCount == 0) {
            if (currentInfo.index == 0) {
              this.text = `您当前还差${nextInfo.requireLevel - assistanceNumber}个助力值可以获得抽奖机会啦，超多大奖等您来拿，赶紧找好友来帮忙点亮吧！`;
            } else {
              this.text = `您当前还差${nextInfo.requireLevel - assistanceNumber}个助力值可以点亮${nextInfo.name}，再次获得抽奖机会，超多大奖等您来拿，赶紧找好友来帮忙点亮吧！`;
            }
          }

          if (assistanceNumber > currentInfo.requireLevel) {
            this.text = `您当前已获得${assistanceNumber}个助力值，还差${nextInfo.requireLevel - assistanceNumber}个助力值可以获得抽奖机会啦，超多大奖等您来拿，赶紧找好友来帮忙点亮吧！`;
          }
        } else {
          // 无 下一站
          if (currentInfo.prizeCount == 0) {
            this.text = `您已成功点亮所有站点，持续找好友帮忙继续冲击排行，更多礼品等您拿`;
          } else if (currentInfo.lotteryTimesInit - currentInfo.userLotteryCount == 0) {
            this.text = `您已成功点亮所有站点，持续找好友帮忙继续冲击排行，更多礼品等您拿！`;
          } else {
            this.text = `您已成功点亮所有站点，获得抽奖机会，持续找好友帮忙继续冲击排行，更多礼品等您拿`;
          }
        }
      }
    },
    message: function (newVal, oldval) {
      console.log(newVal, oldval);
    },
  },
  computed: {},
  mounted() {
    this.configInfo = this.$configInfo;
  },
  methods: {
    //取消领奖
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
    clickBottomBtnConfirm() {
      this.value = false;
      if (this.configInfo.shareSwitch == 1) {
        let text = {
          text1: "邀请好友",
          text2: "还有更多惊喜",
          text3: "",
        };
        this.$modal.share.alert(text).then((data) => {
          if (data == "save") {
            console.log(this.configInfo.shareImg);
            this.$modal.poster.alert({
              gameBg: this.configInfo.shareImg, //分享截图背景图
            });
          }
        });
      }
    },
    clickLuck() {
      this.value = false;
      this.callback("goLuck");
    },
    clickReceive() {
      this.value = false;
      const { currentInfo } = this.message;
      if (currentInfo.residue == 0) {
        return this.$showToast("奖品已被抢完!");
      }
      this.$modal.form.alert({
        type: "prize",
        code: currentInfo.code,
        prizeName: currentInfo.name,
        receiveKey: currentInfo.code,
        prizeType: currentInfo.type,
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@keyframes modal_animate {
  0 {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  &.animate {
    .info {
      animation-name: modal_animate;
    }
  }

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation-timing-function: ease-out;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    transform: scale(0);

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;
      background-color: #fff;

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
        margin-top: 10px;
      }

      .msg1 {
        .test1 {
          font-weight: 600;
          font-size: 18px;
        }

        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
        color: #595959;
        width: 240px;
        margin-bottom: 12px;
      }

      .btnBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 264px;

        .btn {
          width: 120px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          font-size: 20px;
          border-radius: 24px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          font-weight: 600;
        }
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        font-weight: 600;
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
